import { Select } from 'antd';
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useDebouncedCallback } from '../../hooks/useDebouncedCallback';
import unwrapAxiosPromise from '../../util/unwrapAxiosPromise';

export default function SelectConsultivoAcesso({ filter, onChange, value, ...props }) {
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [options, setOptions] = useState([]);

  const fetchSearch = useCallback(search => {
    setLoadingSearch(true);
    unwrapAxiosPromise(axios.get(`/consultivo/acessos`, { params: { search } }))
      .then(data => {
        if (typeof filter === 'function')
          data = data.filter(filter);
        setOptions(data);
      })
      .finally(() => setLoadingSearch(false));
  }, []);

  const handleChange = id => {
    onChange(id);
  };

  const handleSearch = useDebouncedCallback(500, search => {
    fetchSearch(search);
  }, []);

  useEffect(() => {
    fetchSearch();
  }, [fetchSearch]);

  return (
    <Select
      filterOption={false}
      loading={loadingSearch}
      onChange={handleChange}
      onSearch={handleSearch}
      showSearch
      value={value}
      {...props}
    >
      {options.map(option => (
        <Select.Option key={option.id} value={option.id}>
          {option.nome}
        </Select.Option>
      ))}
    </Select>
  );
}

SelectConsultivoAcesso.propTypes = {
  filter: PropTypes.func,
  onChange: PropTypes.func,
  params: PropTypes.any,
  value: PropTypes.number,
};
